<template>
  <el-select v-model="form.distributor" name="distributor" :loading="loading" filterable placeholder="Select a distributor" @change="$emit('input', $event)">
    <el-option v-for="distributor in distributors" :key="distributor.id" :label="distributor.name" :value="distributor.id"></el-option>
  </el-select>
</template>

<script>
export default {
  props: {
    value: {
      default: null,
      type: String,
    },
  },

  data() {
    return {
      loading: true,
      distributors: [],
      form: {
        distributor: this.value,
      },
    }
  },

  async mounted() {
    this.loading = true

    try {
      var { data } = await this.$http.get('/distributors')
    } catch(err) {
      this.$message.error(err.response.data.message)
      return false
    } finally {
      this.loading = false
    }

    this.distributors = data
  },
}
</script>
